import React from 'react'
import getLabel from '../../utilities/label.js'

export default function PreauthFooter(props){
  const {
    // googleStoreUrl,
    // appleStoreUrl,
    privacyPolicyUrl,
    termsAndConditionsUrl
  } = props
  return (
    <div>
      {/* <div className="app-download-callouts">
        <div className="callout android">
          <a
            href={ googleStoreUrl }
            target="_blank"
            rel="noopener noreferrer">
            <img
              src="/callout_googleplay.png"
              alt="Download the Android app" />
          </a>
        </div>
        <div className="callout ios">
          <a
            href={ appleStoreUrl }
            target="_blank"
            rel="noopener noreferrer">
            <img
              src="/callout_appstore.png"
              alt="Download the iOS app" />
          </a>
        </div>
      </div> */}
      <div className="footer">
        <div className="footer-link">
          <a
            className="footer-link-left"
            target="_blank"
            rel="noopener noreferrer"
            href={ privacyPolicyUrl }>
            { getLabel('privacy_policy') }
          </a>
        </div>
        <span className="footer-divider">|</span>
        <div className="footer-link">
          <a
            className="footer-link-right"
            target="_blank"
            rel="noopener noreferrer"
            href={ termsAndConditionsUrl }>
            { getLabel('terms_and_conditions') }
          </a>
        </div>
      </div>
    </div>
  )
}
